import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IProductData, enLang } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { paymentService } from 'services/PaymentService';
import { langService } from 'services/LangService';

interface IState extends IStateBase {
  cart: IProductData;
  lang: enLang;
}

export default class FeeSubscription extends BaseComponent<IState> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ lang: null }, langService.getLang());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart, lang } = this.state;

    return (
      <span>
        {lang !== enLang.PT_BR ? (
          <span className="chk-installment-fee theme-footer">
            You will be billed &nbsp;
            <CurrencyFormat value={cart.subscription.priceTax} />
            &nbsp;of fee on the subscription every &nbsp;{cart.subscription.frequency}
            &nbsp;{paymentService.getNormalizedFrequencyTypeEnUs(cart.subscription.frequencyType, cart.subscription.frequency)}
            {cart.subscription.hasTax ? (
              <span>
                {' '}
                and <CurrencyFormat value={Number(cart.subscription.taxTax.toFixed(2))} /> on membership
              </span>
            ) : null}
          </span>
        ) : null}
      </span>
    );
  }
}
